module.exports = __webpack_public_path__ + "img/img62.90956492.png";